module.exports = __webpack_public_path__ + "img/What-We-Are-BG.e8f65668.jpg";